import { MediaParticipant } from "@dvrt/web-phone-client";
import * as React from "react";
import { useState } from "react";
import { PopoverPosition } from "@mui/material";
import { MenuButton } from "./styles";
import ParticipantMenu from "../../../participant-menu/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ParticipantMenuButton = ({ participant }: { participant: MediaParticipant }) => {
    const [menuPos, setMenuPos] = useState<PopoverPosition>();

    return (
        <React.Fragment>
            <MenuButton
                onClick={(ev) => {
                    setMenuPos({
                        left: ev.clientX,
                        top: ev.clientY,
                    });
                }}
            >
                <FontAwesomeIcon
                    icon="ellipsis-h"
                    style={{ margin: "-2px 0", filter: "drop-shadow(0px 0px 2px black)" }}
                />
            </MenuButton>
            <ParticipantMenu participant={participant} position={menuPos} onClose={() => setMenuPos(null)} />
        </React.Fragment>
    );
};

export default ParticipantMenuButton;
